import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ResultsTab({ results, onDelete, onDeleteByEvent, events }) {
  // Agrupar resultados por evento
  const resultsByEvent = results.reduce((acc, result) => {
    const eventId = result.event_id;
    if (!acc[eventId]) {
      acc[eventId] = {
        event_name: result.event_name || 'Evento Desconhecido',
        results: []
      };
    }
    acc[eventId].results.push(result);
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      {Object.keys(resultsByEvent).length === 0 ? (
        <div className="text-center py-8 text-foreground/50">
          Nenhum resultado cadastrado ainda.
        </div>
      ) : (
        Object.entries(resultsByEvent).map(([eventId, data]) => (
          <div key={eventId} className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="bg-secondary px-4 py-3 flex justify-between items-center">
              <h3 className="font-bold text-primary">{data.event_name}</h3>
              <Button
                size="sm"
                variant="destructive"
                onClick={() => onDeleteByEvent(eventId)}
                className="rounded-sm text-xs"
              >
                <Trash2 className="w-3 h-3 mr-1" />
                Excluir Todos
              </Button>
            </div>
            <table className="w-full">
              <thead className="bg-secondary/50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Pos.</th>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Placa</th>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Participante</th>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Categoria</th>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Tempo</th>
                  <th className="px-4 py-2 text-left text-xs font-bold uppercase tracking-widest text-primary">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {data.results.sort((a, b) => a.position - b.position).map((result) => (
                  <tr key={result.id} data-testid={`result-${result.id}`}>
                    <td className="px-4 py-2 text-sm font-bold text-accent">{result.position}º</td>
                    <td className="px-4 py-2 text-sm font-bold text-foreground">{result.numero_peito || '-'}</td>
                    <td className="px-4 py-2 text-sm text-foreground">{result.participant_name}</td>
                    <td className="px-4 py-2 text-sm text-foreground/70">{result.category}</td>
                    <td className="px-4 py-2 text-sm text-foreground/70">{result.time || '-'}</td>
                    <td className="px-4 py-2">
                      <Button
                        data-testid={`delete-result-${result.id}`}
                        size="sm"
                        variant="destructive"
                        onClick={() => onDelete(result.id)}
                        className="rounded-sm"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}
